import Swiper from 'swiper/js/swiper';

const { $ } = window;

function exteriorFancybox(swiperExteriorWhole, fancyboxID) {
  const fancyboxDefaultsExterior = {
    buttons: [
      'close',
    ],
    touch: true,
    backFocus: false,
    baseClass: 'figure-slide',
    infobar: false,
    animationEffect: 'fade',
    transitionEffect: 'slide',
    // eslint-disable-next-line consistent-return
    clickContent(current) {
      if (current.type === 'image') {
        return false;
      }
    },
    caption() {
      return $(this).find('figcaption').html();
    },
    btnTpl: {
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">'
        + '<i class="icon icon-close"></i>'
        + '</button>',
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">'
        + '<i class="icon icon-nav-arrow"></i>'
        + '</button>',
    },
    onInit() {
      // console.log(instance)
      if ($.fancybox.isMobile) {
        const a = $('body,html').scrollTop() * -1;
        $('body,html').css('top', a).addClass('fancybox-iosfix');
        // console.log(a)
      }
    },
    afterClose() {
      let offset;
      if ($('body,html').hasClass('fancybox-iosfix')) {
        offset = parseInt(document.body.style.top, 10);
        $('body,html').removeClass('fancybox-iosfix').css('top', '').scrollTop(offset * -1);
      }
    },
    beforeClose(instance) {
      const FBcurrIndex = instance.currIndex;

      const FBswiperSlide = $(`[data-fancybox='${fancyboxID}']:eq(${FBcurrIndex})`).closest('.swiper-slide').index();
      swiperExteriorWhole.slideTo(FBswiperSlide, 0);
    },
  };
  $(`[data-fancybox='${fancyboxID}']`).fancybox(fancyboxDefaultsExterior);
}

function initSwiperExteriorWhole(typ, id) {
  const swiperExteriorWhole = new Swiper(`#${typ} #${id} .swiper-container`, {
    slidesPerView: 1,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: `#${typ} #${id} .swiper-button-next`,
      prevEl: `#${typ} #${id} .swiper-button-prev`,
    },
    on: {
      transitionEnd() {
        const active = swiperExteriorWhole.activeIndex;
        const nowActiveNav = $(`#${typ} [data-nav="${id}"].nav-link.active`).attr('data-index');
        // console.log(active);
        if (active < nowActiveNav) {
          $(`#${typ} [data-nav="${id}"].nav-link`).removeClass('active');
          $(`#${typ} [data-nav="${id}"].nav-link[data-index=${nowActiveNav}]`).parent().prev().find('.nav-link')
            .addClass('active');
        } else {
          $(`#${typ} [data-nav="${id}"].nav-link[data-index=${active}]`).trigger('click');
        }
      },
    },
  });

  $(`#${typ} .scroll-menu-list.fancyboxSlide .nav-link`).on('click', function popIndex() {
    const thisIndex = $(this).attr('data-index');
    $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
    $(this).addClass('active');
    // console.log(thisIndex);
    swiperExteriorWhole.slideTo(thisIndex, 500, false);
  });
  exteriorFancybox(swiperExteriorWhole, id);
}

function initSwiperHybrid() {
  const typ = 'hybrid';
  const swiperHybrid = new Swiper(`#${typ} .swiper-hybrid.swiper-container`, {
    slidesPerView: 1,
    centeredSlides: true,
    autoHeight: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: `#${typ} .swiper-button-hybrid.swiper-button-next`,
      prevEl: `#${typ} .swiper-button-hybrid.swiper-button-prev`,
    },
    on: {
      transitionEnd() {
        const active = swiperHybrid.activeIndex;
        console.log(active);
        console.log($(`#${typ} [data-nav="hybrid"].nav-link[data-index=${active}]`));
        if ($(`#${typ} [data-nav="hybrid"].nav-link[data-index=${active}]`).length === 1) {
          $(`#${typ} [data-nav="hybrid"].nav-link[data-index=${active}]`).trigger('click');
        }
      },
    },
  });
  $(`#${typ} .scroll-menu-list.fancyboxSlide .nav-link`).on('click', function popIndex() {
    const thisIndex = $(this).attr('data-index');
    $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
    $(this).addClass('active');
    // console.log(thisIndex);
    swiperHybrid.slideTo(thisIndex, 500, false);
  });
}

function initSwiperExtremely(typ, id) {
  const swiperExtremelyActive = new Swiper(`#${typ} #${id} .swiper-container`, {
    slidesPerView: 1,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: `#${typ} #${id} .swiper-button-next`,
      prevEl: `#${typ} #${id} .swiper-button-prev`,
    },
    on: {
      transitionEnd() {
        const active = swiperExtremelyActive.activeIndex;
        const activeSlide = swiperExtremelyActive.slides[active];
        console.log(active);
        console.log($(`#${typ} [data-nav="#${id}"].nav-link[data-index=${active}]`));
        if ($(`#${typ} [data-nav="#${id}"].nav-link[data-index=${active}]`).length === 1) {
          $(`#${typ} [data-nav="#${id}"].nav-link[data-index=${active}]`).trigger('click');
          $(activeSlide).find('.icon-list li:eq(0)').trigger('click');
        }
      },
    },
  });
  $(`#${typ} #${id} .scroll-menu-list.fancyboxSlide .nav-link`).on('click', function popIndex() {
    const thisIndex = $(this).attr('data-index');
    $(this).closest('.scroll-menu-list').find('.nav-link').removeClass('active');
    $(this).addClass('active');
    console.log(thisIndex);
    swiperExtremelyActive.slideTo(thisIndex, 500, false);
  });
}

function initSpecSwipers(id) {
  const isupgrade = id.indexOf('upgrade') > -1;
  return new Swiper(`#spec #${id} .swiper-container`, {
    slidesPerView: 1.25,
    centeredSlides: true,
    spaceBetween: 25,
    observer: true,
    observeParents: true,
    centerInsufficientSlides: true,
    longSwipesMs: 1000,
    navigation: {
      nextEl: `#spec #${id} .swiper-button-next`,
      prevEl: `#spec #${id} .swiper-button-prev`,
    },
    breakpoints: {
      769: {
        slidesPerView: 2.25,
        slidesPerGroup: 2,
        centeredSlides: false,
      },
      1140: {
        slidesPerView: isupgrade ? 3 : 3.25,
        slidesPerGroup: 3,
        centeredSlides: false,
      },
    },
  });
}

function initSwiper(typ, id) {
  const swiper = new Swiper(`${typ} #${id} .swiper-container`, {
    slidesPerView: 1,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: `${typ} #${id} .swiper-button-next`,
      prevEl: `${typ} #${id} .swiper-button-prev`,
    },
  });

  exteriorFancybox(swiper, id);
}

// 動態依據 engs 建立 Swiper
function initSpec() {
  const engs = $('#spec nav ul li a');
  engs.each((i, e) => {
    const id = $(e).attr('aria-controls');
    initSpecSwipers(id);
  });
}
// 動態依據 Exterior Interior建立 Swiper
function initExteriorInterior() {
  const exterior = $('#exterior nav ul li a').first();
  const exteriorid = exterior.data('nav');
  initSwiperExteriorWhole('exterior', exteriorid);

  const interior = $('#interior nav ul li a').first();
  const interiorid = interior.data('nav');
  initSwiperExteriorWhole('interior', interiorid);

  const gallery = $('#gallery nav ul li a').first();
  const galleryid = gallery.data('nav');
  initSwiperExteriorWhole('gallery', galleryid);
}

// eslint-disable-next-line no-unused-vars
function initExtremely() {
  initSwiperExtremely('extremely', 'extremely-active');
  initSwiperExtremely('extremely', 'extremely-passive');
}

function initGeneral() {
  const grnerals = $('.general .tab-content section');
  grnerals.each((i, e) => {
    const id = $(e).attr('id');
    initSwiper('.general', id);
  });
}

export function initSwipers() {
  initSpec();
  initExteriorInterior();
  initGeneral();
  initSwiperHybrid();

  $(document).on('click', 'a[data-src="#read-more"]', function click() {
    const $div = $(this).closest('div');
    const title = $div.find('h3').text();
    const content = $div.find('p').text();
    const $readMore = $('#read-more');
    $readMore.find('h4').text(title);
    $readMore.find('p').text(content);
  });
}

export default {
  initSwipers,
};
